import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPrediction } from './predictionAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchPredictionDataWithFilters = createAsyncThunk(
  'prediction/fetchPredictionDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchPrediction({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const predictionSlice = createSlice({
  name: 'prediction',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchPredictionDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPredictionDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchPredictionDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectPredictionData = (state) => state.prediction.data;
export const selectPredictionStatus = (state) => state.prediction.status;
export const selectPredictionError = (state) => state.prediction.error;

export default predictionSlice.reducer;
